angular.module('appRouterGuardModule', [])
    .run(['$rootScope', '$q', 'trsHttpService', '$state', 'modalDialog', function($rootScope, $q, trsHttpService, $state, modalDialog) {
        let noPassModuleName; // 没权限的模块名称
        $rootScope.$on('$stateChangeStart', function(event, toState, toParams, fromState, fromParams) {
            if (toState.name === 'front') {return;}
            if (!$rootScope.status || !$rootScope.status.basicAccess) {
                event.preventDefault();
                getBasicAccess().then(() => {
                    if (isPass(toState)) {
                        $state.go(toState.name, toParams, { reload: false });
                        console.log('通过权限校验');
                    } else {
                        modalDialog.alertType(`对不起，您目前没有${noPassModuleName}权限，请联系管理员开通该模块权限`, '', 'warning', 'confirm', () => {
                            $state.go('front', {}, { reload: true });
                        });
                    }
                }, () => {

                });
                return;
            }
            if (!isPass(toState)) {
                event.preventDefault();
                modalDialog.alertType(`对不起，您目前没有${noPassModuleName}权限，请联系管理员开通该模块权限`, '', 'warning', 'confirm', () => {
                    if (isPass(fromState)) {return;}
                    $state.go('front', {}, { reload: true });
                });
            }
        });

        /**
         * [isPass description] 是否放行
         * @param   {[type]}  toState  [toState description]
         * @return  {[type]}           [return description]
         */
        function isPass(toState) {
            // let noPassList = {};
            let accessRouterMap = {
                'editctr': [
                    'front.editctr',
                    'appatlas',
                    'appnews',
                    'appsubject',
                    'appwebsite',
                    'appactivity',
                    'applive',
                    'apptopic',
                    'appvideo',
                    'appaudio',
                    'appPreview',
                    'fusionnews',
                    'fusionatlas',
                    'fusionlinkdoc',
                    'fusionvideo',
                    'fusionlive',
                    'fusionpreview',
                    'iwonews',
                    'iwoatlas',
                    'iwolinkdoc',
                    'iwovideo',
                    'iwobroadcasttvmanuscript',
                    'iwoplannedorder',
                    'iwoplannedorderedit',
                    'iwopreview',
                    'newspaperpic',
                    'newspaperNewsPreview',
                    'televisionmanuscript',
                    'televisionplannedorder',
                    'seriesSheetPreview',
                    'manuscriptPreview',
                    'broadcastmanuscript',
                    'broadcastplannedorder',
                    'broadcastseriesSheetPreview',
                    'broadcastmanuscriptPreview',
                    'websitenews',
                    'websiteatlas',
                    'websitelinkdoc',
                    'websitesubject',
                    'websitevideo',
                    'websiteowner',
                    'websitePreviewAll',
                    'wbeditpage',
                    'wbPreview',
                    'wxeditpage',
                    'weixinPreview'
                ],
                'plan': [
                    'front.plan'
                ],
                'resourcectrl': [
                    'front.resourcectrl',
                    'resourcevideodetail',
                    'resourcevideomaterialdetail',
                    'resourcepicturedetail',
                    'resourcegxgkdetail',
                    'appresourcedetail',
                    'resourcexhsgbigdatadetail',
                    'resourcerobotdetail',
                    'resourcepushdetail',
                    'resourcedetail',
                    'digitaldetailother',
                    'digitaldetailjtcpg'
                ]
            };
            if (!$rootScope.status.basicAccess['editctr']) {
                let isNoPass = accessRouterMap.editctr.some((item) => toState.name.indexOf(item) >= 0);
                if (isNoPass) {
                    noPassModuleName = '采编中心';
                    return false;
                }
            }
            if (!$rootScope.status.basicAccess['plan']) {
                let isNoPass = accessRouterMap.plan.some((item) => toState.name.indexOf(item) >= 0);
                if (isNoPass) {
                    noPassModuleName = '策划中心';
                    return false;
                }
            }
            if (!$rootScope.status.basicAccess['resourcectrl']) {
                let isNoPass = accessRouterMap.resourcectrl.some((item) => toState.name.indexOf(item) >= 0);
                if (isNoPass) {
                    noPassModuleName = '资源中心';
                    return false;
                }
            }
            return true;
        }

        /**
         * [getBasicAccess description：获取一级模块访问权限
         * @return {[null]}  [description]
         */
        function getBasicAccess() {
            let deffer = $q.defer();
            if ($rootScope.status && $rootScope.status.basicAcces) {
                deffer.resolve();
            }
            var params = {
                serviceid: 'mlf_metadataright',
                methodname: 'queryMlfChildModalsWithRight',
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get')
                .then(function(data) {
                    var basicAccess = {};
                    for (var i = 0; i < data.length; i++) {
                        basicAccess[data[i]] = true;
                    }
                    if (angular.isDefined($rootScope.status)) {
                        $rootScope.status.basicAccess = basicAccess;
                    } else {
                        $rootScope.status = {
                            basicAccess: basicAccess
                        };
                    }
                    deffer.resolve();
                }, (err) => {
                });
            return deffer.promise;
        }
    }]);
